import { Container } from '@chakra-ui/react';
import React from 'react';

interface IProps {
	size?: 'lg';
}

export default function PageSectionTemplate(props: React.PropsWithChildren<IProps>) {
	return (
		<Container
			as="section"
			display="grid"
			gridTemplateRows="auto 1fr"
			h="100%"
			maxH="100dvh"
			maxW={{ base: '100%', md: props.size === 'lg' ? 'container.lg' : 'container.md' }}
			overflow="auto"
			px={4}
			pb={2}
		>
			{props.children}
		</Container>
	);
}
